import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TopBar from "./TopBar";
import Divider from "@mui/material/Divider";
import { useEffect } from "react";
import Confirmation from "../CustomerOnboarding/Confirmation";
import AMD from "../../assets/images/AMD.svg";
import GB from "../../assets/images/GB.svg";
import CPU from "../../assets/images/CPU.svg";
import Windows from "../../assets/images/Windows.svg";
import GBPS from "../../assets/images/GBPS.svg";
import Banner from "../../assets/images/banner.svg";
import ConnectLoader from "../../assets/images/connectloader.svg";
import ErrorOutlineSharpIcon from "@mui/icons-material/ErrorOutlineSharp";
import axios from "axios";
function PaymentPlan() {

  const MainHeading = {
    typography: {
      fontFamily: "Roboto Flex",
    },
    // Other styles...
  };

  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const AUTHENTIK_LOGIN_URL = `${SERVER_URI}/ssologin`;
  const GET_SELECTEDPLAN =`${SERVER_URI}/getPlans/`

  const [isLoading, setIsLoading] = React.useState(false);

  const handleSignup = () => {
    window.location.href = "/user_signup"; // Redirect to the payment plan page
  };
  const handleAuthentikButtonClick = () => {
    window.open(AUTHENTIK_LOGIN_URL, "_self");
  };
  const handleRedirectLogin = () => {
    window.location.href = "/user_Login";
  };

  const featureIcons = [AMD, GB, CPU, Windows, GBPS];

  const [selectedPlan, setSelectedPlan] = useState(null);
  const [plan, setPlan] = useState(null);

  useEffect(() => {
    const fetchPlans = async () => {
      const selplan = sessionStorage.getItem("selectedPlan");
      setIsLoading(true);
      try {
        const response = await axios.get(GET_SELECTEDPLAN + selplan);
        setSelectedPlan(response.data); // Assuming the response contains the selected plan
      } catch (error) {
        console.error("Error fetching plans:", error);
      } finally {
        setIsLoading(false);
      }
    };
  
    fetchPlans();
  }, []);
  return (
    <div>
      {/* <TopBar /> */}
      <Box
        sx={{
          padding: "50px",
          backgroundColor: "#fff",
          "@media (max-width: 600px)": {
            padding: "10px",
            flexDirection: "column-reverse",
          },
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            marginTop: "10px",
            "@media (max-width: 791px)": {
              display: "flex",
              flexDirection: "column-reverse",
              "& > :nth-of-type(1)": {
                order: 1, // Plan Details first
              },

              "& > :nth-of-type(3)": {
                order: 2, // Amount third
              },
            },
          }}
        >
          <Grid item xs={12} md={8}>
            <Box
              sx={{
                padding: "20px",
                backgroundColor: "#F1F1F1",
                borderRadius: "10px",
                "@media (max-width: 600px)": { padding: "10px" },
              }}
            >
              <Typography
                sx={{
                  ...MainHeading.typography,
                  fontSize: "24px",
                  fontWeight: 600,
                  lineHeight: "18px",
                  letterSpacing: "0em",
                  textAlign: "left",
                  color: "#1E53E8",
                }}
              >
                Plan Details
              </Typography>
              <Typography
                sx={{
                  ...MainHeading.typography,
                  fontSize: 16,
                  fontWeight: 300,
                  lineHeight: "18px",
                  letterSpacing: "0em",
                  textAlign: "left",
                  color: "#131313",
                  marginTop: "10px",
                }}
              >
                {/* Our secure payment gateway ensures a smooth and hassle-free
                transaction. */}
              </Typography>

              {selectedPlan && (
                <Box
                  sx={{
                    padding: "20px",
                    backgroundColor: "#fff",
                    marginTop: "25px",
                  }}
                >
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        marginTop: "10px",
                        ...MainHeading.typography,
                        fontSize: "24px",
                        fontWeight: 600,
                        lineHeight: "18px",
                        letterSpacing: "0em",
                        textAlign: "left",
                        color: "#1E53E8",
                      }}
                    >
                      {selectedPlan?.planName}
                    </Typography>
                    <ul style={{ paddingLeft: "10px", marginTop: "20px" }}>
  {selectedPlan.features?.map((feature, index) => (
    <li
      key={index}
      style={{
        display: "flex",
        alignItems: "center",
        color: "#1F1F1F",
        fontFamily: "Roboto Flex",
        fontSize: "16px",
        fontWeight: 600,
        lineHeight: "40px",
      }}
    >
        {featureIcons[index] && (
        <img
          src={featureIcons[index]}
          alt={`icon for ${feature}`}
          style={{ width: "24px", marginRight: "10px" }}
        />
      )}
      {feature}
    </li>
  ))}
</ul>
                  </Box>
                </Box>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
          {selectedPlan?.planName !== "Free Trial" && (
            <Box
              sx={{
                backgroundColor: "#F1F1F1",
                padding: "20px",
                borderRadius: "10px",
              }}
            >
              <img src={Banner} alt="" />
              <br />
              <br />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItem: "center",
                  marginBlock: "10px",
                }}
              >
                <Typography
                  sx={{
                    ...MainHeading.typography,
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "left",
                  }}
                >
                  <li>{selectedPlan?.planName} </li>
                </Typography>
                <Typography
                  sx={{
                    ...MainHeading.typography,
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "left",
                  }}
                >
                  ₹{selectedPlan?.amount}
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItem: "center",
                  marginBlock: "10px",
                }}
              >
                <Typography
                  sx={{
                    ...MainHeading.typography,
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "left",
                  }}
                >
                  <li>GST 18%</li>
                </Typography>
                <Typography
                  sx={{
                    ...MainHeading.typography,
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "left",
                  }}
                >
                  ₹{selectedPlan?.amount ? (selectedPlan.amount * 0.18).toFixed(2) : '0.00'}
                </Typography>
              </div>

              <Divider />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItem: "center",
                  marginBlock: "10px",
                }}
              >
                <Typography
                  sx={{
                    ...MainHeading.typography,
                    fontSize: "18px",
                    fontWeight: 600,
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "left",
                  }}
                >
                  Grand Total
                </Typography>
                <Typography
                  sx={{
                    ...MainHeading.typography,
                    fontSize: "18px",
                    fontWeight: 600,
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "left",
                    color: "#1E53E8",
                  }}
                >
                   ₹{selectedPlan?.amount ? (selectedPlan.amount + (selectedPlan.amount * 0.18)).toFixed(2) : '0.00'}
                </Typography>
              </div>

              
            
            </Box>
          )}
          {/* Try It Text */}
          {selectedPlan?.planName === "Free Trial" && (
          <Box
              sx={{
                padding: "20px",
                backgroundColor: "#F1F1F1",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                // marginTop: "20px",
                "@media (max-width: 600px)": { padding: "10px" },
              }}
            >
              {/* Icon */}
              <ErrorOutlineSharpIcon
                sx={{
                  color: "#1E53E8",
                  fontSize: "36px",
                  marginRight: "10px",
                }}
              />

              {/* Text */}
              <Typography
                variant="body1"
                sx={{ color: "#000", fontFamily: "Roboto Flex" }}
              >
                Try it before you buy it. Enjoy a 3-hour free trial to
                experience MegaConnect.
              </Typography>
            </Box>
          )}
              {/* MOBILE VIEW BUTTON */}
              <Box
                sx={{
                  display: "none",
                  "@media (max-width: 791px)": { display: "block" },
                }}
              >
                <Button
                  onClick={handleSignup}
                  sx={{
                    fontFamily: "Roboto Flex",
                    width: "100%",
                    height: "45px",
                    textAlign: "center",
                    marginTop: "30px",
                    backgroundColor: "#C7F760",
                    color: "#1E53E8",
                    textTransform: "none",
                    fontWeight: 900,
                    boxShadow: "none",
                    "&:hover": { backgroundColor: "#1E53E8", color: "#C7F760" },
                  }}
                  variant="contained"
                >
                  Create Account
                </Button>
              </Box>
              <Box
                sx={{
                  display: "none",
                  "@media (max-width: 791px)": { display: "block" },
                }}
              >
                <Button
                  // onClick={checkout}
                  onClick={handleRedirectLogin}
                  sx={{
                    fontFamily: "Roboto Flex",
                    width: "100%",
                    height: "45px",
                    textAlign: "center",
                    marginTop: "30px",
                    backgroundColor: "#C7F760",
                    color: "#1E53E8",
                    textTransform: "none",
                    fontWeight: 900,
                    boxShadow: "none",
                    "&:hover": { backgroundColor: "#1E53E8", color: "#C7F760" },
                    "@media (max-width: 791px)": { display: "block" }
                  }}
                  variant="contained"
                >
                  Login
                </Button>
              </Box>
            {/* WEB VIEW BUTTONS */}
            <Box
              sx={{
                display: "block",
                "@media (max-width: 791px)": { display: "none" },
              }}
            >
              <Button
                onClick={handleSignup}
                sx={{
                  fontFamily: "Roboto Flex",
                  width: "100%",
                  height: "58px",
                  textAlign: "center",
                  marginTop: "30px",
                  backgroundColor: "#C7F760",
                  color: "#1E53E8",
                  textTransform: "none",
                  fontWeight: 900,
                  boxShadow:"none",
                  "&:hover": { backgroundColor: "#1E53E8", color: "#C7F760" },
                }}
                variant="contained"
              >
                Create Account
              </Button>
            </Box>
            <Box
              sx={{
                display: "block",
                "@media (max-width: 791px)": { display: "none" },
              }}
            >
              <Button
                // onClick={checkout}
                onClick={handleRedirectLogin}
                sx={{
                  fontFamily: "Roboto Flex",
                  width: "100%",
                  height: "58px",
                  textAlign: "center",
                  marginTop: "30px",
                  backgroundColor: "#C7F760",
                  color: "#1E53E8",
                  textTransform: "none",
                  fontWeight: 900,
                  boxShadow:"none",
                  "&:hover": { backgroundColor: "#1E53E8", color: "#C7F760" },
                }}
                variant="contained"
              >
                Login
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.5)", // Adjust the opacity as needed
            backdropFilter: "blur(1px)",
            zIndex: 9999, // Ensure the overlay is above other content
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            {/* <ClipLoader color={"#374ad7"} size={50} /> */}
            <img
              src={ConnectLoader}
              alt=""
              style={{ color: "#374ad7", fontSize: "50%" }}
            />
          </Box>
        </div>
      )}

      <div style={{ display: "none" }}>
        <Confirmation
        //   ldapIntegration={LdapIntegration}
        //   mappingVmToDb={MappingVmToDb}
        />
      </div>
    </div>
  );
}

export default PaymentPlan;
